import React, { useEffect, useRef } from 'react';
import { useJarvisState } from '../hooks/useJarvisState';

const SoundEffects: React.FC = () => {
  const { state } = useJarvisState();
  const startListeningSound = useRef<HTMLAudioElement | null>(null);
  const stopListeningSound = useRef<HTMLAudioElement | null>(null);
  const thinkingSound = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    startListeningSound.current = new Audio('/sounds/start-listening.mp3');
    stopListeningSound.current = new Audio('/sounds/stop-listening.mp3');
    thinkingSound.current = new Audio('/sounds/thinking.mp3');

    startListeningSound.current.load();
    stopListeningSound.current.load();
    thinkingSound.current.load();

    if (startListeningSound.current) startListeningSound.current.volume = 0.3;
    if (stopListeningSound.current) stopListeningSound.current.volume = 0.3;
    if (thinkingSound.current) thinkingSound.current.volume = 0.15;
  }, []);

  const playSound = async (sound: HTMLAudioElement | null) => {
    try {
      if (sound && sound.readyState === 4) {
        await sound.play();
      }
    } catch (error) {
      console.warn('Erro ao tocar som:', error);
    }
  };

  useEffect(() => {
    const stopAllSounds = () => {
      [startListeningSound, stopListeningSound, thinkingSound].forEach(sound => {
        if (sound.current) {
          sound.current.pause();
          sound.current.currentTime = 0;
        }
      });
    };

    stopAllSounds();

    switch (state) {
      case 'listening':
        playSound(startListeningSound.current);
        break;
      case 'thinking':
        playSound(thinkingSound.current);
        break;
      case 'idle':
        playSound(stopListeningSound.current);
        break;
    }
  }, [state]);

  return null; 
};

export default SoundEffects;
